import React from 'react'
import './nonBrandedAudiences.scss'
import { SectionWrapper } from '../../../theme/layouts/MainLayout';
import { altLtGray, techBlack } from '../../../common/utils/constant';
import StatsPoint from './../components/stats';
import AppImage from '../../../common/features/image';
import HeroSection, { CtaBrand } from './../components/heroSection';
import { adsBrand } from '../../../common/utils/constant';
// const {page3:{hero}} = adsBrand;

function NonBrandedAudiences() {

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className='page-3'>
      <HeroSection data={adsBrand.audience} />
      <SectionWrapper bg={altLtGray}>
        <section className='section1'>
          <div className="row">
            <div className="col-sm-12 col-md-6 noPad-noMar">
              <p className='sec1-txt-left'>200+ million customers <span className='energy-purple'>and counting.</span></p>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className='serve-shoppers-pad-lft'>
                <p className='sec1-txt-right'>We serve shoppers online, in-store, at home and anywhere they raise their hand to learn more about the latest technology. These highly engaged audiences are the foundation of our advertising solutions, ensuring your ads reach those who are looking to enrich their lives through tech. </p>
              </div>

            </div>
          </div>
          <div className='three-container'>
            <div className="row">
              <div className="col">
                <StatsPoint
                  title={() => <>10B<span className='energy-purple'>+</span></>}
                  subTitle="site page views per year"
                />
              </div>
              <div className="col">
                <StatsPoint
                  title={() => <>103M<span className='energy-purple'>+</span></>}
                  subTitle="store transactions per year"
                />
              </div>
              <div className="col">
                <StatsPoint
                  title={() => <>11M<span className='energy-purple'>+</span></>}
                  subTitle="unique mobile app users"
                />
              </div>
            </div>
          </div>
        </section>
      </SectionWrapper>
      {/* <SectionWrapper>
        <section className='section2'>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <div className='sec2-left-side'>
                Counted on for all things tech.
              </div>
            </div>
            <div className="right-section col-sm-12 col-md-6">
              <div className='home-renovators-pad-lft'>
                <p className='secl-txt-right'>From home renovators to sports enthusiasts to fitness buffs, customers rely on Best Buy for inspiration, guidance and support more than 45 million times per week.</p>
              </div>
            </div>
          </div>
        </section>
      </SectionWrapper> */}
      <SectionWrapper>
        <section className='section2'>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <div className='sec2-left-side'>
                Counted on for all things tech.
              </div>
            </div>
            <div className="col-sm-12 col-md-6">
              <div className='sec2-right-side'>
                From home renovators to sports enthusiasts to fitness buffs, customers rely on Best Buy for inspiration, guidance and support more than 45 million times per week.
              </div>
            </div>
          </div>
        </section>
      </SectionWrapper>
      <section className='audience-section-wrapper'>
        <div className='bg-home-graphic-img row'>
          <div className="col-12 background-home-graphic-img" onContextMenu={(e) => e.preventDefault()}></div>
        </div>
      </section>
      <SectionWrapper bg={techBlack}>
        <section className='promo-section section5'>
          <div className="row">
            <div className="promo-left-content col-sm-12 col-md-6">
              <h2>Dynamic advertising solutions</h2>
              <p className='promo-para-text'>Our full-funnel, omnichannel solutions reach across the entire customer journey. We’re with customers as they learn, imagine, troubleshoot, try and buy.</p>
              <p className='promo-para-text'>And with Best Buy Ads, you’re right there, too.</p>
            </div>
            <div className="col-sm-12 col-md-6">
              <AppImage src={'/images/home/home_360_graphic.svg'} alt="img" className="promo-img" />
            </div>
          </div>
        </section>

      </SectionWrapper>
      <SectionWrapper style={{ background: 'linear-gradient(273.12deg, rgb(0, 70, 190) 0%, rgb(112, 38, 191) 121.29%)' }}>
        <section className='section6'>
          <h3>Relationships are the answer</h3>
          <div className='ready-to-start-padding-right'>
            <p className='text-container'>Ready to start driving results with our data-driven retail media solutions? <a href='javascript:void(0)' className='tech-yellow' onClick={scrollToTop}>Fill out the form</a> above to connect with a retail media expert today and learn more about reaching CE shoppers.</p>
          </div>
          <CtaBrand iconFile={'/images/common/icons/cheveron-yellow-up.png'} page={'audience'}/>
        </section>
      </SectionWrapper>

    </div>
  )
}

export default NonBrandedAudiences